module.exports = __webpack_public_path__ + "img/04.026439df.jpg";